import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=dde42adc&scoped=true"
import script from "./PortalFooter.vue?vue&type=script&lang=js"
export * from "./PortalFooter.vue?vue&type=script&lang=js"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&id=dde42adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde42adc",
  null
  
)

export default component.exports